import React from "react";
const Divider = ({
  borderColor = "#1F254B",
  borderWidth = "2px",
  marginTop = null,
  marginBottom = null,
  borderRadius = null,
  opacity = "1",
}) => {
  return (
    <div
      style={{
        height: "0px",
        border: "solid",
        borderWidth: borderWidth,
        borderColor: borderColor,
        opacity: opacity,
        marginTop: marginTop,
        marginBottom: marginBottom,
        borderRadius: borderRadius,
      }}
    />
  );
};

export default Divider;
